export enum EffyBreakpoints {
  MOBILE_SE = '(max-width: 340px)',
  MOBILE = '(max-width: 767px)',
  MOBILE_LANDSCAPE = '(max-width: 1023px) and (orientation: landscape)',
  IPAD_LANDSCAPE = '(min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape)',
  IPAD_PORTRAIT = '(min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait)',
  DESKTOP = '(min-width: 1024px)',
}
